import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const SingleSelectEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-single-select-edit-view" */ './ui/single-select'),
	),
	getPreloadProps: () => ({}),
});

export default SingleSelectEditViewEntryPoint;
